import { useContextState } from "../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            //maxWidth: '500px',
            width: '500px', //430
            padding: 3,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            maxHeight: 'calc(100% - 68px)',
            overflow: 'auto',
        },
        footer: {
            height: '40px',
            width: 'calc(100% - 48px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'absolute',
            bottom: '16px',
            left: '16px'
        },
        maxInput: {
            maxWidth: '200px',
        },
        addContainer: {
            padding: '8px 8px 8px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        title: {
            color: colors.color13,
            '&.big': {
                fontSize: '18px',
                fontWeight: 'bold',
            }
        },
        add: {
            color: colors.color4,
        },
    }
}

export { useStyles }
